export default __webpack_public_path__ + "static/media/campamento.ec3bec1f.jpeg";